import React from 'react';
import './View.css';

// Import the logos from the images directory
import igisLogo from '../../images/IG3IS _ icon green.png';
import wmoLogo from '../../images/logo_microsite_en.png';

const IG3ISRecognition = () => {
  return (
    <div className="ig3is-recognition-block">
      <div className="ig3is-recognition-content">
        <div className="ig3is-logos">
          <div className="logo-container">
          <img src={wmoLogo} alt="WMO Logo" className="wmo-logo" />
          </div>
          <div className="logo-container">
            <img src={igisLogo} alt="IG3IS Logo" className="igis-logo" />
          </div>
        </div>
        <div className="ig3is-text">
          <p>
            La{' '}
            <a 
              href="https://ig3is.wmo.int/site/integrated-global-greenhouse-gas-information-system-ig3is" 
              target="_blank" 
              rel="noopener noreferrer"
              className="ig3is-link"
            >
              iniciativa IG3IS
            </a>
            {' '}de la{' '}
            <a 
              href="https://wmo.int/es" 
              target="_blank" 
              rel="noopener noreferrer"
              className="wmo-link"
            >
              Organización Meteorológica Mundial (WMO)
            </a>
            {' '}reconoce a{' '}
            <a 
              href="https://respire.bsc.es/noticias/endorsement" 
              target="_blank" 
              rel="noopener noreferrer"
              className="respire-link"
            >
              RESPIRE-CLIMA
            </a>
            {' '}por su desarrollo y aplicación de herramientas avanzadas de modelización y medición de emisiones de gases de efecto invernadero. Los resultados permitirán respaldar a los responsables de políticas de mitigación del cambio climático desde el nivel nacional hasta el local.
          </p>
        </div>
      </div>
    </div>
  );
};

export default IG3ISRecognition;
